/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { textMatcherWith2Decimal } from '../../../../SharedModules/utilities/utilities';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

export const tableHead = [
  {
    headerName: 'Provider ID',

    field: 'providerId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID Type',

    field: 'providerIdTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,

    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider Name',

    field: 'name',

    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_350,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claims',
    field: 'numClaims',
    editable: false,
    excelAlignment: 'right',
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total Reimbursement Amount',

    field: 'totReimbAmt',

    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    isTextColorRed: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
];
